import {environment} from "../../environments/environment";

export function CalcIva(prezzo: number, iva: number){
  return (prezzo /100) *  iva;
}
export function getSettings(tipo: string):{
  nome: string,
  id: string,
  colore: string,
  restRoute: string,
  capacita: string[],
  defaultFilter?: string,
  CampiOfferta?: any[],
  CampiSottoOffertaPreventivo?: any[],
  hideAziendaStatica?: boolean,
} {
  return environment.ProgettiAddon['TipiProgetto']?.find(x => x.id == tipo) ?? {
    nome: 'Offerte',
    id: "T",
    colore: "#1baa03",
    restRoute: "/progetti/progetti",
    capacita: [],

  };
}
export function RestRoute(tipo: string) : string {
  return getSettings(tipo).restRoute ?? "/progetti/progetti";
}
